import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectSelectedFacetCount = (state: RootState) =>
	Object.keys(state?.facets?.selectedFacets)?.length;
